module.exports = __webpack_public_path__ + "static/media/mov.5c4b2db2.png";